/**
 * A restrained hue per author, so every Essence by the same author shares a
 * tint (a hairline and a faint corner glow). Six cosmic hues only.
 */
const HUES = [262, 238, 214, 292, 184, 330] as const;

export function authorTintHue(author: string): number {
  let hash = 0;
  for (let i = 0; i < author.length; i++) {
    hash = (hash * 31 + author.charCodeAt(i)) | 0;
  }
  return HUES[Math.abs(hash) % HUES.length];
}

export function tintStyle(author: string): React.CSSProperties {
  return { ["--tint-h" as string]: String(authorTintHue(author)) };
}
